var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "textarea-editor" },
    [
      _c("editor-content", { attrs: { editor: _vm.editor } }),
      _c(
        "div",
        { staticClass: "textarea-editor-options" },
        [
          _c("div", { staticClass: "left-options" }, [
            _c(
              "div",
              { staticClass: "container-icon" },
              [
                _c("i", {
                  staticClass: "fa-regular fa-face-laugh",
                  on: {
                    click: function ($event) {
                      _vm.displayEmojiPicker = !_vm.displayEmojiPicker
                    },
                  },
                }),
                _c("Picker", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.displayEmojiPicker,
                      expression: "displayEmojiPicker",
                    },
                  ],
                  ref: "emojiPicker",
                  style: _vm.pickerStyle,
                  attrs: {
                    data: _vm.emojiIndex,
                    i18n: {
                      search: "Rechercher un Emoji",
                      notfound: "Aucun emoji trouvé",
                      categories: {
                        search: "Résultats de recherche",
                        recent: "Utilisés fréquemment",
                        smileys: "Émoticônes & Émotion",
                        people: "Personnes & Corps",
                        nature: "Animaux & Nature",
                        foods: "Nourriture & Boissons",
                        activity: "Activité",
                        places: "Voyages & Lieux",
                        objects: "Objets",
                        symbols: "Symboles",
                        flags: "Drapeaux",
                        custom: "Personnalisé",
                      },
                    },
                    color: "#b64985",
                  },
                  on: { select: _vm.addEmoji },
                }),
              ],
              1
            ),
            _vm.showOptionBold
              ? _c(
                  "div",
                  {
                    staticClass: "container-icon",
                    class: { disable: !_vm.hasSelection },
                    on: {
                      click: function ($event) {
                        return _vm.onBoldButton()
                      },
                    },
                  },
                  [_c("i", { staticClass: "fa-solid fa-bold" })]
                )
              : _vm._e(),
            _vm.showOptionItalic
              ? _c(
                  "div",
                  {
                    staticClass: "container-icon",
                    class: { disable: !_vm.hasSelection },
                    on: {
                      click: function ($event) {
                        return _vm.onItalicButton()
                      },
                    },
                  },
                  [_c("i", { staticClass: "fa-solid fa-italic" })]
                )
              : _vm._e(),
            _c(
              "div",
              {
                staticClass: "container-icon",
                class: { disable: _vm.disableHashtag },
                on: {
                  mousedown: function ($event) {
                    $event.preventDefault()
                    return _vm.onHashtagButton.apply(null, arguments)
                  },
                },
              },
              [
                _c("i", { staticClass: "fa-solid fa-hashtag" }),
                !_vm.compactOption ? _c("p", [_vm._v("Hashtag")]) : _vm._e(),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "container-icon",
                class: { disable: _vm.disableMention },
                on: { click: _vm.onMentionButton },
              },
              [
                _c("i", { staticClass: "fa-solid fa-at" }),
                !_vm.compactOption ? _c("p", [_vm._v("Mention")]) : _vm._e(),
              ]
            ),
          ]),
          _vm.ShowCounterCharacters
            ? _c(
                "Tooltip",
                {
                  attrs: {
                    position: "bottom",
                    classCustom: "right-options",
                    active: _vm.textInfoMaxCharacters.length,
                    text: _vm.textInfoMaxCharacters,
                  },
                },
                [
                  _vm.maxCharacters !== Infinity &&
                  _vm.charactersLength > _vm.maxCharacters
                    ? _c("i", { staticClass: "fa-solid fa-circle-exclamation" })
                    : _vm._e(),
                  _c(
                    "p",
                    { staticClass: "count" },
                    [
                      _c(
                        "span",
                        {
                          class: {
                            red:
                              _vm.maxCharacters !== Infinity &&
                              _vm.charactersLength > _vm.maxCharacters,
                          },
                        },
                        [_vm._v(_vm._s(_vm.charactersLength))]
                      ),
                      _vm.maxCharacters !== Infinity
                        ? [
                            _vm._v("\n                    /"),
                            _c("span", [_vm._v(_vm._s(_vm.maxCharacters))]),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }